import React from "react";
import { Col, Row, Collapse, Statistic, Card } from "antd";
import { Image } from "react-bootstrap";
import { Icon } from "semantic-ui-react";

function Dashboard({
  school: { schoolName, image, desc, employees, levels, students },
}) {
  const { Panel } = Collapse;

  // useEffect(() => {
  //   first

  //   return () => {
  //     second
  //   }
  // }, [third])

  return (
    <>
      <Row gutter={[24, 16]} justify="start">
        <Col span={19}>
          <Row gutter={[24]} className="p-3">
            <Col span={6}>
              <Image
                src={image || `${process.env.REACT_APP_DEF_IMAGE}`}
                roundedCircle
                fluid
                loading="eager"
              />
            </Col>
            <Col span={18}>{desc}</Col>
          </Row>
          <Row gutter={[24, 16]} className="p-4">
            <Col span={8}>
              <Card hoverable title="Card title" bordered>
                Card content
              </Card>
            </Col>
            <Col span={8}>
              <Card hoverable title="Card title" bordered>
                Card content
              </Card>
            </Col>
            <Col span={8}>
              <Card hoverable title="Card title" bordered>
                Card content
              </Card>
            </Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col>More Info</Col>
          </Row>
          <Row>
            <Col span={24}>
              <Collapse
                bordered={false}
                defaultActiveKey={["1", "2", "3"]}
                ghost
              >
                <Panel header="Employees" key="1">
                  <Row justify="center">
                    <Col>
                      <Statistic
                        title="Number of employees"
                        value={employees?.length}
                        prefix={<Icon name="users" color="purple" />}
                      />
                    </Col>
                  </Row>
                </Panel>
                <Panel header="Students" key="2">
                  <Row justify="center">
                    <Col>
                      <Statistic
                        title="Number of students"
                        value={2000}
                        prefix={<Icon name="student" color="green" />}
                      />
                    </Col>
                  </Row>
                </Panel>
                <Panel header="Levels" key="3">
                  <Row justify="center">
                    <Col>
                      <Statistic
                        title="Number of levels"
                        value={levels}
                        prefix={
                          <Icon name="angle double up" color="dodger blue" />
                        }
                      />
                    </Col>
                  </Row>
                </Panel>
              </Collapse>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default Dashboard;
